import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3ltt834j6o: FaireBrandEntity = {
  token: "b_3ltt834j6o",
  type: "brand",
  name: "Sundream",
  avatarUrl:
    "https://cdn.faire.com/fastly/2c1039e31cbbd94701ca5b1956f881e2baa3bc110a2895802d2ab4d8520c8d1e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/95bc1d684dd99eccd00466e76bf3c99962e253fdb91811d4d51ef9150c5a9ded.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2c1039e31cbbd94701ca5b1956f881e2baa3bc110a2895802d2ab4d8520c8d1e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/95bc1d684dd99eccd00466e76bf3c99962e253fdb91811d4d51ef9150c5a9ded.png",
  location: "Ventura, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 184,
  isTopShop: true,
  isInsider: true,
  description:
    "The Blanket Company 🌞 Designed in Ventura, CA - Enjoyed Everywhere! \nOur flagship collection is artisan made in Mexico with 100% up-cycled materials.\n\nCrafted on traditional looms, our weaving artists dedicate their skill to each & every blanket.  We are honored to have worked with the same team of artisan weavers for over a decade! Providing them fair wages and the ability to preserve their art form as a thriving occupation. We proudly carry out a centuries-old tradition in the creation of our modernized take on these blankets that we get to share with you!\n\nWhy your customers will love Sundream:\n- Made of reclaimed fibers derived from 100% post consumer materials\n- Woman-owned business based in Ventura, California\n- Handwoven by artisans\n- Modern designs and colors paired with centuries-old hand-woven tradition\n- Equally soft and durable these throws become softer and softer over time!\n- Soft enough for your bed and durable for weekend adventures\n\nFor bulk and custom order inquiries (50 units+) please reach out to: [redacted-email] (not .com) :) \nCustom designs + custom logo woven label bulk orders! \n\nPlease don't hesitate to reach out with any questions!\nWe are very active on Faire Messenger.\n\nWe look forward to working with you :) \n- Casey & Brooke",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:06.859Z",
    importedBy: "entity-db-cli",
  },
};
